import MuiTextField from '@mui/material/TextField';
import type { ComponentProps, ForwardedRef } from 'react';
import { forwardRef } from 'react';

type TextInputProps = Omit<
  ComponentProps<typeof MuiTextField>,
  'error' | 'helperText'
> & {
  readOnly?: boolean;
  error?: string;
  alwaysShrinkLabel?: boolean;
  step?: number;
  disableUnderline?: boolean;
};

export const TextInput = forwardRef(function CustomInput(
  {
    error,
    disabled,
    readOnly,
    alwaysShrinkLabel,
    disableUnderline,
    ...props
  }: TextInputProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <MuiTextField
      slotProps={{
        ...(disableUnderline && { input: { disableUnderline } }),
        ...(readOnly && { input: { readOnly } }),
        ...(alwaysShrinkLabel && { inputLabel: { shrink: true } }),
      }}
      {...props}
      disabled={disabled}
      hiddenLabel
      variant={props.variant ?? 'outlined'}
      error={!!error}
      helperText={error}
      ref={ref}
    />
  );
});
